import React, { useState, useEffect } from "react"

import { Form } from "react-bootstrap"

import InputField from './elements/input'
import SelectField from './elements/select'
import TextAreaField from './elements/textarea'
import CheckboxField from './elements/checkbox'
import RadioField from './elements/radio'
import ButtonField from './elements/button'
import HtmlBox from './elements/html'
import ReCaptchaBox from './elements/recaptcha'
import { postFormData } from "./api/Api"
import $ from 'jquery'

import axios from "axios"
import * as qs from "query-string"

import "./assets/styles/Form.scss";

function ReachForm(props) {
  const [startDate, setStartDate] = useState();

  const [validated, setValidated] = useState(false);
  const [showerror, setShowerror] = useState(false);
  const [showthankyou, setThankyou] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState("");

  const [formvalues, setFormvalues] = useState("");

  const [token, setToken] = useState("");

  const myRef = React.createRef();

  const recaptchaRef = React.createRef();

  const fields = ([
    {
      element: "config",
      formname: "Contact",
      error_text: "Highlighted fields are required | invalid",
      success_text: "Thank you for your interest. A member of our team will contact you shortly.",
      email_temp_user: "contact_user",
      email_temp_admin: "contact_admin",
      email_server_func: "contact",
      event_tracking: "contact",
      page_url: "/contact"
    },

    {
      grpmd: "12",
      label: "Name*",
      placeholder: "Your Name *",
      name: "name",
      type: "text",
      element: "input",
      required: true,
      patternchk: "^[-a-zA-Z0-9-()]+(\\s+[-a-zA-Z0-9-()]+)*$",
      labelClass: "text-xs-bold"
    },
    {
      grpmd: "12",
      label: "Email*",
      placeholder: "Your Email Address *",
      name: "email",
      type: "email",
      element: "input",
      required: true,
      patternchk: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$",
      labelClass: "text-xs-bold"

    },
    {
      grpmd: "12",
      label: "Telephone*",
      placeholder: "Your Phone Number *",
      name: "telephone",
      type: "text",
      element: "input",
      required: true,
      patternchk: ".{14,25}",
      labelClass: "text-xs-bold"
    },

    {
      grpmd: "12",
      label: "Message",
      placeholder: "Leave your message",
      name: "message",
      element: "textarea",
      class: "",
      rows: "2",
      labelClass: "text-xs-bold"
    },
    {
      grpmd: "12",
      name: "Send Message",
      type: "submit",
      element: "button",
      value: "submit",
      class: "btn-primary",
      step: "col-md-4 submit-btn-wrap",
      formclass: "banner_submit_btn form-submit-btn"
    },
    {
      text: 'By clicking Send Enquiry, you agree to our <a class="content-link text-xxs">Terms & Conditions</a> and <a href="/privacy-policy/" class="content-link text-xxs">Privacy Policy</a>',
      element: "html",
      class: "frmbtmtext text-xxs col-12"
    },
    {
      element: "captcha",
      class: "captcha-class",
      captchaRef: recaptchaRef
    },
    {
      name: "negotiatoremail",
      type: "hidden",
      element: "input",
      defaultValue: props.subject?.negotiator?.Email
    }
  ]);

  const handlechange = event => {
    // remove initial empty spaces
    event.target.value = event.target.value.trimStart()
  }

  useEffect(() => {
    if (token !== '') {

      const processFromData = async () => {

        let formData = new FormData();
        const kendal_data = {
          "name": formvalues.name, 
          "email": formvalues.email, 
          "telephone": formvalues.telephone,
          "comments": formvalues.message,
          "form_name": formvalues.formname
        };
      
        formvalues['kendal_data'] = kendal_data;
        formvalues['g-recaptcha-response'] = token;

        formvalues['extra'] = JSON.stringify({ message: formvalues.message }); 

        formData.append('data', JSON.stringify(formvalues));


        postFormData(formData).then(async apiRes => {


          window.grecaptcha.reset() 
        
          formvalues['email_subject_user'] = 'Contact Person';
          formvalues['email_subject_admin'] = 'Contact Person';
          await window.fetch(`${process.env.GATSBY_CLOUD_URL}/api/form`, {
            method: `POST`,
            mode: "no-cors",
            headers: {
              'Access-Control-Allow-Origin': '*',
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: qs.stringify(formvalues),
          })
        });


       
        // tracking event
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'formSubmit',
          'formType': fields[0].formname +'- Person '+ props.subject.peopleName,
          'formId': 'form-' + fields[0].event_tracking,
          'formName': fields[0].formname +' '+ props.subject.peopleName,
          'formLabel': fields[0].formname +' '+ props.subject.peopleName,
          'username': formvalues.name,
          'email': formvalues.email,
          'phone': formvalues.telephone,
        });

        setShowerror(false);
        setThankyou(true);
        setTimeout(() => {
          $(".alert-success").show().delay(4000).fadeOut();
        }, 500)

        myRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' })

      }
      processFromData();

    }
  }, [token]);

  const handleonVerify = token => {
    console.log("captcha verified");
    setToken(token);
  };

  const handleSubmit = event => {

    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setShowerror(true);
      setValidated(true);
      setThankyou(false);
      myRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' })
    }
    else {

      event.preventDefault();

      const formsdata = (event.target);
      const json = {}
      Object.keys(formsdata).map(key => (
        json[formsdata[key].name] = (formsdata[key].checked) ? 'yes' : formsdata[key].value
      ))

      json['email_temp_user'] = fields[0].email_temp_user;
      json['email_temp_admin'] = fields[0].email_temp_admin;
      json['formname'] = fields[0].formname; 
      json['g-recaptcha-response'] = token;

      setFormvalues(json);
      //setToken("test");
      recaptchaRef.current.execute();

      setValidated(false);

      // reset form
      const form = event.target
      form.reset();
      setStartDate()
    }
  };

  return (
    <div className="form stbform valuation-main book-a-viewing-form">
      <div ref={myRef} />
      <div className="form stbform">

        {showerror && <div className="alert-error">
          <p>{fields[0].error_text}</p>
        </div>}

        {showthankyou && <div className="alert-success">
          <p>{fields[0].success_text}</p>
        </div>}

        <div className="row">
        <Form className="form-wrap reach-us-form" name={fields[0].formname}   method="post" noValidate validated={validated} onSubmit={handleSubmit} >
          <input type="hidden" name="form_name" value={fields[0].formname} />
          <input type="hidden" name="form_type" value={fields[0].form_type} />
          <input type="hidden" name="bot-field" />
          <div className="step-block">
            {fields.map((field, index) => {
              if ("input" === field.element) {
                return (
                  <InputField
                    name={field.name}
                    grpmd={field.grpmd}
                    ref={field.ref}
                    type={field.type}
                    startDate={field.type === 'date_time' ? startDate : ''}
                    setStartDate={field.type === 'date_time' ? setStartDate : ''}
                        phoneNumber={field.name === 'telephone' ? phoneNumber : ''}
                        setPhoneNumber={field.name === 'telephone' ? setPhoneNumber : ''}
                    fieldClass={field.class}
                    placeholder={field.placeholder}
                    label={field.label}
                    labelClass={field.labelClass}
                    required={field.required}
                    key={`${field.element}~${index}`}
                    pattern={field.patternchk}
                    handlechange={handlechange}
                  />
                );
              }
              if ("select" === field.element) {
                return (
                  <SelectField
                    name={field.name}
                    grpmd={field.grpmd}
                    ref={field.ref}
                    required={field.required}
                    fieldClass={field.class}
                    placeholder={field.placeholder} 
                    label={field.label}
                    labelClass={field.labelClass}
                    values={field.values}
                    key={`${field.element}~${index}`}
                    handlechange={handlechange}
                    componentprops={props}
                  />
                );
              }
              if ("textarea" === field.element) {
                return (
                  <TextAreaField
                    name={field.name}
                    grpmd={field.grpmd}
                    ref={field.ref}
                    rows={field.rows}
                    fieldClass={field.class}
                    label={field.label}
                    labelClass={field.labelClass}
                    placeholder={field.placeholder}
                    required={field.required}
                    key={`${field.element}~${index}`}
                    handlechange={handlechange}
                  />
                );
              }
              if ("checkbox" === field.element) {
                return (
                  <CheckboxField
                    name={field.name}
                    ref={field.ref}
                    value={field.value}
                    fieldClass={field.class}
                    placeholder={field.placeholder}
                    label={field.label}
                    labelClass={field.labelClass}
                    required={field.required}
                    key={`${field.name}~${index}`}
                    handlechange={handlechange}
                  />
                );
              }
              if ("radio" === field.element) {
                return (
                  <RadioField
                    name={field.name}
                    ref={field.ref}
                    value={field.value}
                    fieldClass={field.class}
                    checked={field.checked}
                    placeholder={field.placeholder}
                    label={field.label}
                    labelClass={field.labelClass}
                    required={field.required}
                    key={`${field.name}~${index}`}
                    handlechange={handlechange}
                    lastchild={field.lastchild}
                  />
                );
              }
              if ("html" === field.element) {
                return (
                  <HtmlBox
                    text={field.text}
                    fieldClass={field.class}
                    key={`${field.element}~${index}`}
                  />
                );
              }
              if ("captcha" === field.element) {
                return (
                  <ReCaptchaBox
                    fieldClass={field.class}
                    captRef={field.captchaRef}
                    key={`${field.element}~${index}`}
                    handleonVerify={handleonVerify}
                  />
                );
              }
              if ("button" === field.element) {
                return (
                  <ButtonField
                    name={field.name}
                    fieldClass={field.class}
                    step={field.step}
                    formclass={field.formclass}
                    type={field.type}
                    value={field.value}
                    key={`${field.element}~${index}`}
                  />
                );
              }
            })
            }
          </div>
        </Form>
        </div>
      </div>
    </div>
  );
}


const ReachFormPage = (props) => (
  <ReachForm subject={props}  />
)

export default ReachFormPage